import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const DRAFT_PROGRESS_STEPS = [
  'Przygotowujemy temat i kontekst',
  'Zbieramy najwazniejsze informacje',
  'Ukladamy czytelny plan szkicu',
  'Tworzymy pierwsza wersje tresci',
  'Dopracowujemy jezyk i plynnosc',
  'Sprawdzamy spojność calego szkicu'
];

const FINAL_PROGRESS_STEPS = [
  'Rozwijamy szkic do pelnego artykulu',
  'Rozszerzamy sekcje o konkretne przyklady',
  'Porzadkujemy strukture i kolejnosc tresci',
  'Dopracowujemy styl i czytelnosc',
  'Przygotowujemy finalna wersje do zapisu'
];

const FullScreenLoader = ({
  type
}) => {
  const { t } = useTranslation();
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const progressSteps = type === 'draft' ? DRAFT_PROGRESS_STEPS : FINAL_PROGRESS_STEPS;

  const currentProgressStep = useMemo(() => {
    const idx = Math.min(
      progressSteps.length - 1,
      Math.floor(elapsedSeconds / 8)
    );
    return progressSteps[idx];
  }, [elapsedSeconds, progressSteps]);

  const estimatedProgress = useMemo(() => {
    // Soft progress so UI visibly changes while backend works.
    const maxVisible = type === 'draft' ? 92 : 95;
    const speed = type === 'draft' ? 1.4 : 1.1;
    return Math.min(maxVisible, Math.round(elapsedSeconds * speed));
  }, [elapsedSeconds, type]);

  const elapsedLabel = useMemo(() => {
    if (elapsedSeconds < 60) return `${elapsedSeconds}s`;
    const mins = Math.floor(elapsedSeconds / 60);
    const secs = elapsedSeconds % 60;
    return `${mins}m ${secs}s`;
  }, [elapsedSeconds]);

  useEffect(() => {
    setElapsedSeconds(0);
    const interval = setInterval(() => {
      setElapsedSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [type]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center opacity-90">
      <div className="text-center max-w-2xl px-6">
        <p className="text-xl font-semibold mb-2">
          {type === 'draft'
            ? t('articles.create.loader.titleDraft')
            : t('articles.create.loader.titleContent')}
        </p>
        <p className="text-lg text-gray-600 mb-4">
          {currentProgressStep}
        </p>

        <div className="w-full max-w-md mx-auto mt-4">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary-500 rounded-full transition-all duration-700 ease-out"
              style={{ width: `${estimatedProgress}%` }}
            />
          </div>
        </div>

        <div className="mt-4 text-xs text-gray-500 space-y-1">
          <p>Trwa: {elapsedLabel}</p>
          <p>To potrwa okolo minuty.</p>
        </div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
